import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-54">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm" data-id="element-55">
        <p className="mb-6 font-medium text-slate-300" data-id="element-56">
          © 2026 KIT Psicología del Insomnio. Todos los derechos reservados.
        </p>

        <div className="max-w-3xl mx-auto space-y-4 text-xs leading-relaxed opacity-80" data-id="element-57">
          <p data-id="element-58">
            Este material es una herramienta educativa y profesional para
            psicólogos y terapeutas. No reemplaza formación específica,
            supervisión profesional, evaluación médica, interconsulta cuando
            corresponda ni criterios clínicos individuales.
          </p>
          <p data-id="element-59">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </div>
    </footer>;
}